__turbopack_context__.v({
  "ingress__container": "Vnpxya_ingress__container",
  "intro": "Vnpxya_intro",
  "links": "Vnpxya_links",
});
